/* global Emails, Forms, Editor */

import { post } from '@rails/request.js'

const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm'
const FLATPICKR_FORMAT = 'd.m.Y H:i'

window.Emails = {}

Emails.initPositionSelect = function (positionSelect, hiddenInput) {
  let id, klass
  if (hiddenInput.val()) {
    klass = hiddenInput.val().split(',')[0]
    id = hiddenInput.val().split(',')[1]
    positionSelect.find('option[data-klass="' + klass + '"][data-id="' + id + '"]').prop('selected', 'selected')
  } else {
    positionSelect.find('option').filter(function (index, el) {
      $(el).data('id') && $(el).data('klass')
    }).first().prop('selected', 'selected')
  }
  return positionSelect.off('change').on('change', function () {
    klass = $(this).find('option:selected').data('klass')
    id = $(this).find('option:selected').data('id')
    return hiddenInput.val(klass + ',' + id)
  }).trigger('change')
}

Emails.initForm = function () {
  Forms.initCheckbox()
  Emails.initTemplateSelect()
  Emails.initJobAdSelect()
  Emails.initTemplateTagFilter('#templ_id')
  Emails.initSendLater()
  Emails.initPositionSelect()
  Emails.initAddFileFromUploads()
  Emails.initContactPersonChange()
  Emails.initSelect2()

  $('input#email_subject').on('keyup change', function () {
    if (!$('#email_position_select2').hasClass('hidden') && $('#email_position_select2').val() === '') {
      // disable 'send' for a template with the {{position}} if position not selected
      $('#email-send-later-btn').attr('disabled', true)
      $('#email-submit').prop('disabled', true)
    } else {
      $('#email-send-later-btn').attr('disabled', !$(this).val())
      $('#email-submit').prop('disabled', !$(this).val())
    }
  }).trigger('change')

  $('#emails_preview').on('show.bs.modal', function (e) {
    const editor = $('#email_body').data('editor')
    if (!editor) return e.preventDefault()

    const container = $(this).find('.email-preview-container')
    const id = container.attr('data-id')
    const klass = container.attr('data-klass')

    container.addClass('loading')

    let parentController = ''
    if (gon.application.portal === false && klass && id) {
      parentController = `/${klass}/${id}`
    }

    post(
      parentController + '/emails/preview/',
      {
        responseKind: 'script',
        body: {
          signature: $('#new_email #email_add_signature').prop('checked'),
          signature_id: $('#signature_id').val(),
          body: editor.value,
          position: $('#new_email #position').val(),
          klass: $('#new_email #klass').val()
        }
      }
    ).finally(() => {
      container.removeClass('loading')
    }).catch(error => {
      console.error('Preview failed:', error)
    })
  })

  $('#emails_preview').on('show.bs.hidden', function () {
    $(this).find('.email-preview-container').addClass('loading')
  })
  $('#new_email input[type="submit"], #emails_preview_link').on('click', function (e) {
    const editor = $('#email_body').data('editor')
    if (!editor) {
      e.preventDefault()
      return e.stopPropagation()
    }

    const valid = Editor.checkValidity(editor)
    $(editor.element).parents('form').addClass('submited')
    if (!valid) {
      e.preventDefault()
      return e.stopPropagation()
    }
  })
}

Emails.initTemplateSelect = function () {
  $(document).off('change', '#templ_id').on('change', '#templ_id', function () {
    newEmailAction(
      {
        id: $('#templ_id option:selected').val(),
        event_id: $('#email_event_id').val(),
        position_id: $('#email_position').val()
      }
    )
  })
}

Emails.initPositionSelect = function () {
  $(document).on('change', '#email_position', function () {
    newEmailAction(
      {
        id: $('#templ_id option:selected').val(),
        event_id: $('#email_event_id').val(),
        position_id: $('#email_position').val()
      }
    )
  })
}

Emails.initJobAdSelect = function () {
  $(document).off('change', '#job_ad_id').on('change', '#job_ad_id', function () {
    newEmailAction(
      { job_ad_id: $('#job_ad_id').val() }
    )
  })
}

Emails.initTemplateTagFilter = function (template_select) {
  const $templateSelect = $(template_select)
  const trigger = '#template_tag_filter_trigger'
  const collection = $('option[data-tags]', $templateSelect)
  const prompt = $('option:not([data-tags])', $templateSelect)
  $(document).on('click', trigger, function (e) {
    $('#email_template_tag').select2('open')
    $('#template_tag_filter').removeClass('invisible')
  })

  $('#email_template_tag').on('select2-close', function () {
    $('#template_tag_filter').addClass('invisible')
  })

  $(document).off('change', '#email_template_tag').on('change', '#email_template_tag', function (e) {
    const tag = e.target.value
    const filteredCollection = collection.filter(function (i, option) {
      const optionTags = $(option).data('tags')
      return optionTags.split(',').indexOf(tag) !== -1
    })
    $(trigger).find('i').toggleClass('green', !!tag) // indicate for active filter
    $('#template_tag_filter').addClass('invisible')
    $templateSelect.html(filteredCollection).prepend(prompt).val('').trigger('change')
  })
}

Emails.initCancellationEmailTemplates = function () {
  // Change email template
  $(document).off('change', '#cancellation_template_id').on('change', '#cancellation_template_id', function () {
    $.ajax('/dashboard/change_email_template', {
      type: 'GET',
      dataType: 'script',
      data: {
        id: $('#cancellation_template_id option:selected').val(),
        reject: $('#reject').val()
      }
    })
  })

  // Email preview
  $('#dashboards_talent_pool_confirmation_email_preview, #dashboards_talent_pool_reject_email_preview').on('show.bs.modal', (e) => {
    $(e.target).find('#bodyContent').html(Editor.getValue($(e.relatedTarget).parents('form').find('#body')))
  })
}

Emails.initFollowUp = function () {
  const jqselector_parent_container = 'form.new_email'
  const jqselector_container = 'div.follow-up-input-container'
  const jqselector_btn_show = 'a.email-show-follow-up-btn'
  const jqselector_btn_remove = 'a.email-remove-follow-up-btn'
  const jqselector_datepicker = '#email_follow_up_date'
  const container_backup = $(jqselector_container).html()
  const display = function (visible) {
    $(jqselector_btn_show).toggleClass('hidden', visible)
    const content = visible ? container_backup : ''
    $(jqselector_container).html(content)
    Forms.initDatePickers(jqselector_container)
  }
  display(false)
  $(jqselector_parent_container).on('click', jqselector_btn_show, function (e) {
    return display(true)
  })
  $(jqselector_parent_container).on('click', jqselector_btn_remove, function (e) {
    return display(false)
  })
}

Emails.initSendLater = function () {
  const send_later_btn = $('#email-send-later-btn')
  if (!send_later_btn.length) return

  const delivery_date_input = $('#email_delivery_date')
  const btn_icon = send_later_btn.find('i')

  // Destroy any existing flatpickr instance before re-initializing
  // (email template XHR reloads can leave stale instances that crash on .trimEnd())
  const existingFp = send_later_btn[0]?._flatpickr
  if (existingFp) existingFp.destroy()

  const now = moment()
  const minDate = now.format(DATETIME_FORMAT)
  const maxDate = now.add(1, 'month').format(DATETIME_FORMAT)

  const flatpickr = send_later_btn.flatpickr({
    dateFormat: FLATPICKR_FORMAT,
    enableTime: true,
    time_24hr: true,
    minDate,
    maxDate,
    position: 'above',
    onChange: (dates) => {
      const formattedDeliveryDate = moment(dates[0]).format(DATETIME_FORMAT)
      const deliveryDate = moment(dates[0]).format()
      delivery_date_input.val(deliveryDate)
      send_later_btn.find('span.delivery-date').text(formattedDeliveryDate)
      btn_icon.removeClass('fa-clock').addClass('fa-times ml-2')
    },
    onReady: (dateObj, dateStr, instance) => {
      const calendarContainer = $('.flatpickr-calendar.hasTime')
      calendarContainer.append(`<div class='flatpickr-close'>${I18n.t('calendar.actions.apply')}</div>`)
      calendarContainer.find('.flatpickr-close').on('click', function () {
        instance.close()
      })
    }
  })

  btn_icon.on('click', (e) => {
    if (delivery_date_input.val()) {
      setTimeout(flatpickr.close, 100)
      delivery_date_input.val('')
      send_later_btn.find('span.delivery-date').text('')
      send_later_btn.blur()
      btn_icon.removeClass('fa-times ms-2').addClass('fa-clock')
    }
  })
}

Emails.initAddFileFromUploads = function () {
  $('#new_email_attachment').on('click', '.uploaded-image', function () {
    const attachment_relation_id = $(this).data('id')

    newEmailAction(
      {
        id: $('#templ_id option:selected').val(),
        event_id: $('#email_event_id').val(),
        position_id: $('#email_position').val(),
        attachment_relation_id
      }
    )
  })
}

Emails.initContactPersonChange = function () {
  /**
   * IMPORTAND: disable all previous event listeners
   * to avoid duplicating onChange handlers
   */
  $(document).off('change', '#email_to')

  // Add new onChange handler
  $(document).on('change', '#email_to', function () {
    const formAction = this.closest('form').getAttribute('action')

    if (formAction.match(/^\/contact_people/) === null) { return }

    const contactPersonId = this.selectedOptions[0].getAttribute('data-id')

    newEmailAction(
      {
        id: $('#templ_id option:selected').val(),
        event_id: $('#email_event_id').val(),
        position_id: $('#email_position').val(),
        new_contact_person_id: contactPersonId
      }
    )
  })
}

Emails.initSelect2 = function () {
  const emailOptionTemplate = (data) => {
    const el = data.element[0]

    return $(
      `<span class="text">${el.getAttribute('data-name')}</br>
        <small class="text-muted">${el.getAttribute('data-email')}
      </small></span>`
    )
  }

  $('.to-select2#email_to').select2({
    formatSelection: function (d) {
      return $(`<span class="text">${d.element[0].getAttribute('data-name')}</span>`)
    },
    formatResult: emailOptionTemplate
  })

  $('.сс-select2#email_cc').select2({
    formatSelection: function (d) {
      return $(`<span class="text">${d.element[0].getAttribute('data-name')}</span>`)
    },
    formatResult: emailOptionTemplate
  })
}

function newEmailAction (attrs) {
  $.ajax(($('form.new_email').attr('action')) + '/new', {
    type: 'GET',
    dataType: 'script',
    data: attrs
  })
}
